import { defineMessages, useIntl } from 'react-intl';
import { Menu } from 'semantic-ui-react';
import cx from 'classnames';
import { CSSTransition } from 'react-transition-group';

import MobileNavigationHeader from '../Header/MobileNavigationHeader';
import MobileNavigation from './MobileNavigation';
import NavItem from './NavItem';
import { useNavigation } from './NavigationContext';
import type { NavigationItem } from './types';

const messages = defineMessages({
  closeMobileMenu: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
  openMobileMenu: {
    id: 'Open menu',
    defaultMessage: 'Open menu',
  },
});

interface NavigationInnerProps {
  items: NavigationItem[];
  type?: string;
}

const NavigationInner = ({ items, type }: NavigationInnerProps) => {
  const intl = useIntl();

  const {
    toggleMobileMenu,
    closeMobileMenu,
    isMobileMenuOpen,
  } = useNavigation();

  return (
    <>
      {items.length > 0 && (
        <div className="hamburger-wrapper mobile tablet only">
          <button
            className={cx('hamburger hamburger--spin', {
              'is-active': isMobileMenuOpen,
            })}
            aria-label={
              isMobileMenuOpen
                ? intl.formatMessage(messages.closeMobileMenu, { type })
                : intl.formatMessage(messages.openMobileMenu, { type })
            }
            title={
              isMobileMenuOpen
                ? intl.formatMessage(messages.closeMobileMenu, { type })
                : intl.formatMessage(messages.openMobileMenu, { type })
            }
            type="button"
            onClick={toggleMobileMenu}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
        </div>
      )}

      <Menu
        stackable
        pointing
        secondary
        className="computer large screen widescreen only"
        onClick={closeMobileMenu}
      >
        {items.map((item) => (
          <NavItem key={item.url} item={item} />
        ))}
      </Menu>

      <CSSTransition
        in={isMobileMenuOpen}
        timeout={500}
        classNames="mobile-menu"
        unmountOnExit
      >
        <div key="mobile-menu-key" className="mobile-menu">
          <div className="mobile-menu__header-slot">
            <MobileNavigationHeader closeMobileMenu={closeMobileMenu} />
          </div>

          <Menu
            borderless
            stackable
            className="mobile-menu__menu"
          >
            <MobileNavigation items={items} />
          </Menu>
        </div>
      </CSSTransition>
    </>
  );
};

export default NavigationInner;
